import React from 'react';
import { useIntl } from 'react-intl';
import {
  music24PlanCapabilities,
  MUSIC24_TRIAL_DAYS,
  MUSIC24_TRIAL_LEVEL_TIER,
} from 'fym-common/src/license/music24Plans';
import { TypedMemo } from '../../../common/types';
import { planNameMessages } from '../../config/music24PlanNames';
import { Panel } from '../../components/primitives/Panel';
import { SMLButton } from '../../components/primitives/SMLButton';
import { useStartBrowseTrial } from '../hooks/useStartBrowseTrial';
import { browseCreditMessages as messages } from '../browseMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowseRail.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * Owner answer 5: a Free owner who never had a trial starts the 7-day trial here, once per
 * account. The server decides who may (`browse.usage` `trialAvailable`) and refuses a second one.
 */
const BrowseTrialOfferComponent: React.FC = () => {
  const intl = useIntl();
  const { start, isPending, failed, started } = useStartBrowseTrial();
  const credits = music24PlanCapabilities[MUSIC24_TRIAL_LEVEL_TIER].dailyBrowseCredits;

  return (
    <Panel nested tone="brand" className={styles.trialBox} data-testid="browse-trial-offer">
      <h4 className={styles.trialTitle}>
        {intl.formatMessage(messages.trialTitle, {
          plan: intl.formatMessage(planNameMessages[MUSIC24_TRIAL_LEVEL_TIER]),
          days: MUSIC24_TRIAL_DAYS,
        })}
      </h4>
      <p className={styles.rule}>{intl.formatMessage(messages.trialBody, { count: credits })}</p>
      {started ? (
        <p className={styles.rule}>{intl.formatMessage(messages.trialStarted)}</p>
      ) : (
        <SMLButton
          variant="primary"
          disabled={isPending}
          onClick={() => {
            start().catch(console.error);
          }}
        >
          {intl.formatMessage(messages.trialStart)}
        </SMLButton>
      )}
      {failed && (
        <p className={styles.errorLine} role="alert">
          {intl.formatMessage(messages.trialFailed)}
        </p>
      )}
    </Panel>
  );
};

export const BrowseTrialOffer = TypedMemo(BrowseTrialOfferComponent);
